<template>
    <div>
        <div class="evidenceBox">
            <div class="evidenceTitle">
                <h4>证据存证</h4>
                <p style="border: 1px solid #3b63f6"></p>
            </div>
            <div class="evidenceList">
                <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage">
                    <template slot-scope="scope" slot="menu">
                        <el-button  class="View" @click="details">已上传证据</el-button>
                        <el-button  class="View" @click="supplement">补充证据</el-button>
                        <el-button  class="View">提交立案</el-button>
                    </template>
                </avue-crud>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "evidence",
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 60,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [
                    {
                        title:'借款合同',
                        number:'15646515616',
                        time:'2022.10.15 15:05:20',
                        state:'已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }, {
                        title:'借款合同 （2022）',
                        number:'16515616516',
                        time:'2022.10.18 12:01:05',
                        state: '已完成'
                    }
                ],
                option:{
                    addBtn:false,
                    stripe:true,
                    menuWidth:380,//操作栏宽度设置
                    refreshBtn:false, // 刷新按钮
                    columnBtn:false, //列动态显隐按钮
                    delBtn:false, // 行删除按钮
                    editBtn:false, // 行编辑按钮
                    align:'center',
                    menuAlign:'center',
                    column:[
                        {
                            label:'合同标题',
                            prop:'title',
                            search:true,
                        }, {
                            label:'签署编号',
                            prop:'number',
                            search:true,
                        }, {
                            label:'发起时间',
                            prop:'time',
                            type:'datetime',
                            searchRange:true,
                            search:true,
                        }, {
                            label:'合同状态',
                            prop:'state'
                        }
                    ]
                },
            };
        },
        methods:{
            changePage(num){
            },
            //跳转详情
            details(){
                this.$router.push('/particulars')
            },
            //补充证据
            supplement(){
                this.$router.push('/supplement')
            }
        },
        created() {
            this.data.length=this.page.pageSize
        }
    }
</script>

<style scoped>
    .evidenceBox{
        padding: 30px;
        /*height: 100px;*/
        background-color: #fff;
    }
    .evidenceTitle>h4{
        width: 80px;
        color: #3b63f6;
        text-align: center;
        margin-bottom: 8px;
    }
    .evidenceTitle>p{
        width: 80px;
    }
    .evidenceList{
        margin-top: 30px;
    }
    /deep/.avue-form__menu{
        width: 25%;
    }
    /deep/.avue-form__group{
        align-items: flex-end;
    }
    .View{
        background-color: #3b63f6;
        color: #fff;
    }
</style>
